import './create-shortcut-pc-popup.html';
import CreateShortcutPcPopup from './create-shortcut-pc-popup.js';

export default CreateShortcutPcPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/create-shortcut-pc-popup/index.js